import ErrorUtil from '../error/ErrorUtil';
import API from '../util/ApiUtil';

export interface Address {
  id: string;
  addInformation?: string;
  label?: string;
  label2?: string;
  region?: string;
  street?: string;
  buildingName?: string;
  buildingId: string;
  apartment?: string;
  addressType?: string;
  postalCode?: string;
  rooms?: Room[];
}

export interface Room {
  roomId?: string;
  roomName?: string;
}

class AddressStore {
  public fetchAddressResult = async (queryString: string): Promise<Address[]> => {
    if (!queryString) {
      return Promise.resolve([]);
    }
    try {
      const result = await API.get('/address/suggest', {
        params: { term: queryString },
        timeout: 30000
      });
      return result.data;
    } catch (e) {
      ErrorUtil.pushErrorToTeliaRumAndLog(e);
      return [];
    }
  };

  public getAddressById = async (addressId: string, buildingId: string): Promise<Address> => {
    try {
      const result = await API.get(`/address/${addressId}/${buildingId}`, { timeout: 30000 });
      return result.data;
    } catch (e) {
      ErrorUtil.pushErrorToTeliaRumAndLog(e);
      return null;
    }
  };
}

export default AddressStore;
